// Shared scroll-offset math used by both section-progress.js (pin scrolling/highlighting)
// and next-section-button.js (scroll-to-next-section), so the two features can't drift apart.

export function getStickyOffset() {
  const stickyArea = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
  return stickyArea + 16;
}

export function maxScrollTop() {
  return Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
}

// Clamped the same way the browser itself clamps window.scrollTo, so an element near the
// bottom of the page and the current scroll position agree on being "there" even when the
// page can't scroll far enough to put that element exactly at the offset line.
export function targetScrollTop(el) {
  return Math.min(Math.max(el.offsetTop - getStickyOffset(), 0), maxScrollTop());
}

export function scrollToElement(el) {
  window.scrollTo({ top: targetScrollTop(el), behavior: 'smooth' });
}
